import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

/**
 * Under a journal whose rows are already shown but could not be re-read —
 * typically right after a withdrawal: the rows stay, and the reader is told
 * they may no longer be current instead of taking them as fresh evidence.
 */
export function JournalRefreshFailedNotice({ onRetry }: { onRetry: () => void }) {
  const { t } = useTranslation(['settings', 'common']);
  return (
    <div className="flex items-center justify-between gap-2" role="alert">
      <p className="text-xs text-danger">{t('consent.journalRefreshFailed')}</p>
      <Button variant="ghost" size="sm" onClick={onRetry}>
        {t('common:common.retry', 'Retry')}
      </Button>
    </div>
  );
}
